<h1 class="__header">Upload Your Floor Plan</h1>
<p class="__desc">Upload an image of your floor plan, then drag and drop your devices to their locations.</p>

<awair-image-uploader (fileUpload)="onFileUpload($event)">
  <awair-button class="__upload-button">
    <awair-map-icon class="__map-icon" [color]="'#FFFFFF'"></awair-map-icon>
    Upload
  </awair-button>
</awair-image-uploader>
